/**
 * Чи писала вже людина план **на цьому пристрої**.
 *
 * Потрібне рівно одному: підказці на порожній сторінці дня. Порожня картка
 * не пояснює нічого, а показувати пояснення щоразу, коли день порожній, —
 * значить пояснювати вічно: кожен майбутній день порожній за визначенням.
 *
 * Прапорець свідомо **не** синхронізується. Це не дані щоденника, а знання
 * про інтерфейс, і воно належить пристрою: новий пристрій у тієї самої
 * людини — це новий екран, який теж варто пояснити. Класти таке в
 * зашифрований архів означало б возити службові дрібниці разом із записами.
 */
const KEY = "beresta.wrotePlan";

/** Сховище може бути недоступним — приватне вікно, вимкнені дані сайту. */
function storage(): Storage | null {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
}

export function planEverWritten(): boolean {
  try {
    return storage()?.getItem(KEY) === "1";
  } catch {
    // Недоступне сховище означає «не знаємо». Показати підказку зайвий раз
    // безпечніше, ніж не показати її тому, кому вона потрібна.
    return false;
  }
}

export function rememberPlanWritten(): void {
  try {
    storage()?.setItem(KEY, "1");
  } catch {
    // Переповнене сховище не має ламати сторінку дня.
  }
}
